import gql from 'graphql-tag';

export const RemoveSpaceLink = gql`
	mutation SideNavigationRemoveSpaceLink($id: String!, $spaceKey: String!) @experimental {
		experimentalRemoveSpaceLink(id: $id, spaceKey: $spaceKey)
	}
`;
